module.exports = __webpack_public_path__ + "static/media/no-assets-selected.f950e0bf.jpg";